import { useQuery } from 'react-query'
import { removeDefaultParams } from 'src/common/utils'
import { IFilter } from 'src/components/filter/types/filter.types'
import { QUERY_KEYS } from 'src/constants'
import { changeLogService } from 'src/services/change-log.service'

export const initialChangesFilterValues = {
  query: '',
  account: ['all'],
  user: ['all'],
  relation_form: ['all'],
  type: ['all'],
}

const useChanges = (filter?: IFilter) => {
  return useQuery(
    [QUERY_KEYS.CHANGES, filter],
    () =>
      changeLogService.getChanges(removeDefaultParams({ ...filter }, initialChangesFilterValues)),
    { keepPreviousData: true },
  )
}

export { useChanges }
